import { onApiError } from "../error"
import { state } from "../state"
import { del, get, put } from "./client"

async function deleteUser() {
    const user = await state.getActiveUser()
    const res = await del(`/users/${user.Id}`)
    if (!res.ok) throw await onApiError(res)
}

/**
 * @param {string} userId
 * @returns {Promise<User>}
 */
async function getUser(userId) {
    const res = await get(`/users/${userId}`)
    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {PutUserParams} args
 */
async function putUser(args) {
    const user = await state.getActiveUser()
    const res = await put(`/users/${user.Id}`, {
        body: JSON.stringify(args)
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * Only admin access
 * @param {string} userId 
 * @param {string} email 
 * @returns {Promise<User>}
 */
async function putUserEmail(userId, email) {
    const res = await put(`/users/${userId}/email`, {
        body: JSON.stringify({
            Email: email,
        }),
    })
    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * Only admin access
 * @param {string} userId 
 * @returns {Promise<User>}
 */
async function putUserVerifyEmail(userId) {
    const res = await put(`/users/${userId}/verify-email`)
    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    deleteUser,
    getUser,
    putUser,
    putUserEmail,
    putUserVerifyEmail,
}
